export function experimentFormatContent(
  template: string,
  values: Record<string, string> = {},
  defaultValue = '-'
): string {
  return template.replace(/\{(.*?)\}/g, (_, key: string) => values[key] ?? defaultValue)
}
